import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { ACCOUNT_STORE } from '@core/stores/account.store';
import { DEFAULT_INSPECTION_FILTERS } from '@inspections/consts';

export const RESET_INSPECTION_FILTERS_GUARD: CanActivateFn = (): boolean => {
  inject(ACCOUNT_STORE).updateAccountStateInspectionFilters(
    DEFAULT_INSPECTION_FILTERS
  );

  return true;
};
